import { PageLoader } from "@components/ui/PageLoader"
import { Navigate } from "react-router-dom"

import { useOnboardingGate } from "../hooks"

interface Props {
  children: React.ReactNode
}

/**
 * Sits between <ProtectedRoute> and the AppShell. Redirects unfinished
 * onboarding to /bienvenida (PRD-03 FR-2 / FR-3). The actual decision lives
 * in `useOnboardingGate` so the wizard's symmetric "ready -> /" redirect
 * uses the same logic.
 */
export function OnboardingGate({ children }: Props) {
  const status = useOnboardingGate()

  if (status === "loading") return <PageLoader />
  if (status === "needs_onboarding") return <Navigate to="/bienvenida" replace />
  return <>{children}</>
}
